import { Routes, RouterModule } from '@angular/router';
import { MultiApoScreenComponent } from './screens/multi-apo-screen/multi-apo-screen.component';

export const APORoutes: Routes = [
    { path: 'multi-search', component: MultiApoScreenComponent },
    { path: '', redirectTo: 'new', pathMatch: 'full' },
    { path: '**', redirectTo: '/404' }

];

export const APORoutingModule = RouterModule.forChild(
    APORoutes
);
